import React from 'react';

import { Typography, Link } from '../../../components/Wrappers/Wrappers.jsx';
import { DefaultURLs } from '../../../utils/constants';
import { useStyles } from './goodToKnowSection.styles';

const FAQ_ITEMS = [
    {
        id: 'what-gets-listed',
        q: 'What gets listed?',
        a: (classes) => (
            <>
                Your tile is listed on{' '}
                <Link
                    href={DefaultURLs.ECAL_WORLD}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={classes.ecalWorldLink}
                >
                    ecalworld.com
                </Link>{' '}
                for easy discovery and recommendation. Visitors who choose to &apos;Sync to
                Calendar&apos; will see your primary display.
            </>
        ),
    },
    {
        id: 'how-long-until-appears',
        q: 'How long until it appears?',
        a: 'Listings publish to ECAL World within seconds of saving. Turning discovery off removes the listing just as quickly.',
    },
    {
        id: 'choose-primary-display',
        q: 'How do I choose my primary display?',
        a: 'You can select your primary display from within the Manage Displays section of your admin.',
    },
    {
        id: 'does-it-cost-anything',
        q: 'Does it cost anything?',
        a: 'Listing on ECAL World is included with your plan. Featured placement is allocated by the ECAL team based on campaign fit and timing.',
    },
];

function GoodToKnowSection () {
    const classes = useStyles();

    return (
        <div className={classes.card}>
            <Typography variant={'h5'} weight={'bold'} className={classes.heading}>
                Good to know
            </Typography>

            <div className={classes.grid}>
                {FAQ_ITEMS.map((item) => (
                    <div key={item.id}>
                        <Typography variant={'body1'} className={classes.itemQuestion}>
                            {item.q}
                        </Typography>
                        <Typography variant={'body2'} className={classes.itemAnswer}>
                            {typeof item.a === 'function' ? item.a(classes) : item.a}
                        </Typography>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default GoodToKnowSection;
